import React from "react";
import { ProjectSearchPageContent, ProjectSearchPageStateProvider } from ".";
import { UserSearchDialogStateProvider } from "../dialog/user-search-dialog/UserSearchDialogStateProvider";
import { ComponentSearchDialogStateProvider } from "../dialog/component-search-dialog/ComponentSearchDialogStateProvider";

export const ProjectSearchPage = () => {
  return (
    <UserSearchDialogStateProvider>
      <ComponentSearchDialogStateProvider>
        <ProjectSearchPageStateProvider>
          <ProjectSearchPageContent></ProjectSearchPageContent>
        </ProjectSearchPageStateProvider>
      </ComponentSearchDialogStateProvider>
    </UserSearchDialogStateProvider>
  );
};
